import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from './shared/services/config.service';
import { LabelService } from './shared/services/label.service';

interface Env {
  [k: string]: string
}

@Injectable({
  providedIn: 'root'
})
export class AppInitService {

  private readonly CONFIG_URL = 'assets/config/config.json';
  private readonly LABEL_URL = 'assets/i18n/i18n.en.json';
  private readonly httpPrivateClient: HttpClient
  constructor(
    private readonly http: HttpClient,
    private readonly http_handler: HttpBackend,
    private readonly configService: ConfigService,
    private readonly labelService: LabelService
  ) {
    this.httpPrivateClient = new HttpClient(http_handler);
  }


  loadConfiguration() {
    return new Promise<void>((resolve, reject) => {
      this.httpPrivateClient.get<Env>(this.CONFIG_URL).subscribe({
        next: (response: Env) => {
          this.configService.config = response;
          resolve();
        },
        error: (error) => {
          console.error('AppInitService loadConfiguration failed', error);
          reject(error);
        }
      });
    });
  }

  loadLabels() {
    return new Promise<void>((resolve, reject) => {
      this.httpPrivateClient.get(this.LABEL_URL).subscribe({
        next: (response) => {
          this.labelService.labels = response;
          resolve();
        },
        error: (error) => {
          console.error('AppInitService loadLabels failed', error);
          reject(error);
        }
      });
    });
  }

}
